import { render, staticRenderFns } from "./Reports.vue?vue&type=template&id=3630bc93&scoped=true"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"
import style0 from "./Reports.vue?vue&type=style&index=0&id=3630bc93&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3630bc93",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3630bc93')) {
      api.createRecord('3630bc93', component.options)
    } else {
      api.reload('3630bc93', component.options)
    }
    module.hot.accept("./Reports.vue?vue&type=template&id=3630bc93&scoped=true", function () {
      api.rerender('3630bc93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/purchaseService/components/sections/Reports.vue"
export default component.exports